module.exports = __webpack_public_path__ + "img/tw.43eed198.svg";